export enum ShareFormFields {
  ShareType = 'shareType',
  Link = 'link',
  Password = 'password',
  AddedMedia = 'addedMedia',
  RemovedMedia = 'removedMedia',
  CurrentPortfolioId = 'currentPortfolioId',
}

export const ShareFormFieldsList = [
  ShareFormFields.ShareType,
  ShareFormFields.Link,
  ShareFormFields.Password,
  ShareFormFields.AddedMedia,
  ShareFormFields.CurrentPortfolioId,
  ShareFormFields.RemovedMedia,
];
